import { useNavigate } from "react-router-dom";

export default function ProtocolosPage() {
  const navigate = useNavigate();
  return (
    <div className="p-4 md:p-6 space-y-5 animate-fade-in-up">
      <div>
        <h1 className="text-xl md:text-2xl font-bold text-foreground-950">Protocolos de Actuación</h1>
        <p className="text-sm text-foreground-500 mt-0.5">Accede rápidamente a los protocolos según el tipo de situación</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {[
          { 
            label: "Violencia Escolar", 
            icon: "ri-shield-flash-line", 
            query: "¿Cuál es el protocolo de actuación en caso de violencia escolar entre estudiantes?" 
          },
          { 
            label: "Acoso Escolar / Bullying", 
            icon: "ri-emotion-sad-line", 
            query: "¿Cuál es el protocolo de actuación en caso de acoso escolar o bullying?" 
          },
          { 
            label: "Agresión a Funcionario", 
            icon: "ri-user-unfollow-line", 
            query: "¿Cuál es el protocolo en caso de agresión física o verbal a un docente o funcionario?" 
          },
          { 
            label: "Consumo de Sustancias", 
            icon: "ri-capsule-line", 
            query: "¿Cuál es el protocolo en caso de sospecha o hallazgo de consumo de sustancias o drogas?" 
          },
          { 
            label: "Desregulación Emocional", 
            icon: "ri-mental-health-line", 
            query: "¿Cómo actuar frente a una situación de desregulación emocional o crisis en el aula?" 
          },
          { 
            label: "Vulneración de Derechos", 
            icon: "ri-alert-line", 
            query: "¿Cuál es el protocolo frente a sospecha de vulneración de derechos de un estudiante?" 
          },
        ].map((item) => (
          <button
            key={item.label}
            onClick={() => navigate(`/ia/consulta?q=${encodeURIComponent(item.query)}`)}
            className="bg-white border border-background-200/80 rounded-2xl p-5 flex items-start gap-4 hover:border-primary-300 hover:shadow-sm transition-all cursor-pointer text-left w-full"
          >
            <span className="flex items-center justify-center w-10 h-10 rounded-xl bg-primary-50 text-primary-500 flex-shrink-0">
              <i className={`${item.icon} text-xl`} />
            </span>
            <div>
              <p className="text-sm font-semibold text-foreground-900">{item.label}</p>
              <p className="text-xs text-foreground-500 mt-1">Consultar protocolo con Asistente IA →</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}